import {
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import { useState } from "react";
import Swal from "sweetalert2";
import "./crearSubcategoriaDewey.css";
import { crearSubcategoriaDewey } from "../../../services/SubcategoriaDeweyService";

export function CreateDeweySubcategory({
  codigoCategoriaDewey,
  onAdd,
  isOpen,
  setIsOpen,
}) {
  const [nuevaSubcategoria, setNuevaSubcategoria] = useState({
    codigoSubcategoria: "",
    nombreSubcategoria: "",
    categoria: {
      codigoCategoria: codigoCategoriaDewey,
    },
  });

  const handleChange = (e) => {
    setNuevaSubcategoria({
      ...nuevaSubcategoria,
      [e.target.name]: e.target.value,
    });
  };

  const handleCrearSubcategoria = async () => {
    try {
      const newSubcategory =
        await crearSubcategoriaDewey(nuevaSubcategoria);
      setIsOpen(false);
      onAdd(newSubcategory);
      Swal.fire({
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        title: "Éxito!",
        text: "La subcategoría se ha guardado con éxito.",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    } catch (error) {
      setIsOpen(false);
      Swal.fire({
        title: "Error!",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        text: "No se pudo guardar la subcategoría.",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle>Crear Nueva Subcategoría</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="codigoSubcategoria"
          label="Código de la Subcategoría"
          type="text"
          fullWidth
          variant="outlined"
          value={nuevaSubcategoria.codigoSubcategoria}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="nombreSubcategoria"
          label="Nombre de la Subcategoría"
          type="text"
          fullWidth
          variant="outlined"
          value={nuevaSubcategoria.nombreSubcategoria}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCrearSubcategoria} color="success">
          Guardar
        </Button>
        <Button onClick={() => setIsOpen(false)} color="error">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
